export type { ScriptData, ScriptChildren } from "./types"
export { useModel as useScriptEntity } from "./model/useModel"

export const ExceptionScripts = {
  MeetingsOne: "vstrechi_1",
}
